import { render, staticRenderFns } from "./EmpresaBlocoUploadVerificacao.vue?vue&type=template&id=1dee04dc&lang=pug"
import script from "./EmpresaBlocoUploadVerificacao.vue?vue&type=script&lang=js"
export * from "./EmpresaBlocoUploadVerificacao.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBlocoUploadVerificacao.vue?vue&type=style&index=0&id=1dee04dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports